import { Box, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import AppLoader from "../../../components/AppLoader";
import ExportButton from "../../../components/ExportButton";
import { setServiceId } from "../../../lib/CompanySlice/ServiceIdSlice";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import { getAllCompanyServices } from "../../../services/company/serviceCategoryApiFn";
import { handleOpenSnackBar } from "../../../utils";
import GlobalTable from "./../../../components/Tables/GlobalTable";
import { t } from "i18next";

const headerData = ["image", "name", "description", "actions"];

const tableRows = [
  "avarar_image",
  "category_name",
  "category_description",
  "actions",
];

const Category = () => {
  const dispatch = useDispatch();
  const [allServices, setAllServices] = useState([]);
  const [isLoading, setIsLoading] = useState();
  const activeTab = useSelector((state) => state.activeTab.tabs);
  const userData = useSelector((state) => state.userData.user);

  useEffect(() => {
    fetchAllServices();
  }, []);

  const fetchAllServices = async () => {
    try {
      setIsLoading(true);
      const response = await getAllCompanyServices(userData?.adminId);
      if (response?.data?.status === "success") {
        let services = response.data.data.map((c) => ({
          _id: c.services._id,
          image: c.services.image,
          name: c.services.name,
          description: c.services.description,
        }));
        setAllServices(services);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleNavigateServiceDetails = (row) => {
    dispatch(setServiceId(row._id));
    dispatch(
      setActiveTab({ ...activeTab, company_catalogue: "category_details" })
    );
  };

  const renderRightPart = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <ExportButton handleClick={() => console.log("helllo")} />
      </Stack>
    );
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <AppContainer
        primaryHeading={t("listOfServiceCategories")}
        secondaryHeading={t("viewAllMainServices")}
        headProps={renderRightPart()}
        showSerach={true}
      >
        <Box mt={2}>
          <Typography
            mb={1}
            variant="h6"
            fontWeight={500}
            textTransform={"capitalize"}
          >
            {t("currentlyAdded")}
          </Typography>

          <GlobalTable
            tableHeader={headerData}
            displayRows={tableRows}
            tableData={allServices}
            showDetailBtn={true}
            handleNavigateToDetail={handleNavigateServiceDetails}
          />
        </Box>

        {/* <Box mt={2}>
        <Stack
          mb={1}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Typography variant="h6" fontWeight={500}>
            More Services
          </Typography>
          <Typography variant="h6" fontWeight={500} color={"primary.main"}>
            Just upgrade your package
          </Typography>
        </Stack>
        <DynamicTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={TableData1}
          showDetail={true}
          handleNavigate={() => alert("hello")}
        />
      </Box> */}
      </AppContainer>
    </>
  );
};

export default Category;
